import { render, staticRenderFns } from "./detail_config_dataset_group_add.vue?vue&type=template&id=60a8ae32"
import script from "./detail_config_dataset_group_add.vue?vue&type=script&lang=js"
export * from "./detail_config_dataset_group_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports